import './ganttEditing.css';
import * as React from 'react';
import { GanttComponent, EditDialogFieldsDirective, DayMarkers, EditDialogFieldDirective, Inject, Edit, 
        Selection, Toolbar, ColumnsDirective, ColumnDirective, EventMarkersDirective, EventMarkerDirective, 
        ContextMenu, HolidaysDirective, HolidayDirective,
        ExcelExport, PdfExport} from '@syncfusion/ej2-react-gantt';
//import {config} from '../../../_helpers';
import { authenticationService } from '../../../_services';
import { DataUtil, DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { CheckBox } from "@syncfusion/ej2-buttons";
import { TextBox, NumericTextBox, MaskedTextBox } from "@syncfusion/ej2-inputs";
import { DatePicker, DateTimePicker } from "@syncfusion/ej2-calendars";
import { ComboBoxComponent,DropDownList } from "@syncfusion/ej2-react-dropdowns";
import { editingData/* , editingResources */ } from './data_gantt';
import { SampleBase } from '../../../syncfusion/sample-base';
import { setCulture,loadCldr,L10n  } from '@syncfusion/ej2-base';
import * as gregorian from 'cldr-data/main/es-CO/ca-gregorian.json';
import * as numbers from 'cldr-data/main/es-CO/numbers.json';
import * as timeZoneNames from 'cldr-data/main/es-CO/timeZoneNames.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
import * as L10n_es from '@syncfusion/ej2-locale/src/es.json'
//import { Thickness } from '@syncfusion/ej2-react-charts';
//import * as datosjson from './data.json'

setCulture("es-CO");
L10n.load({"es-CO":L10n_es.es});
//DataUtil.serverTimezoneOffset = 5;

export class ganttEditing extends SampleBase {
    constructor() {
        super(...arguments);
        this.state = {loading:true,
          loadingProjects:true,
          hideDialog: false,
          data: null};

        // Variables del Gantt

        this.config = window.config; 
        this.inputs = {
          booleanedit: CheckBox,
          dropdownedit: DropDownList,
          datepickeredit: DatePicker,
          datetimepickeredit: DateTimePicker,
          maskededit: MaskedTextBox,
          numericedit: NumericTextBox,
          stringedit: TextBox
        };
        this.taskFields = {
            id: 'TaskID',
            name: 'TaskName',
            startDate: 'StartDate',
            endDate: 'EndDate',
            duration: 'Duration',
            progress: 'Progress',
            parentID: 'ParentId',
            dependency: 'Predecessor',
            child: 'subtasks',
            notes: 'info',
            resourceInfo: 'resources',
            baselineStartDate: 'BaselineStartDate',
            baselineEndDate: 'BaselineEndDate',
        };
        this.resourceFields = {
            id: 'resourceid',
            name: 'resourcename'
        };
        this.projectFields = { 
            text: 'projectname', 
            value: 'projectid' };
        this.value = "";
        this.editSettings = {
            allowAdding: true,
            allowEditing: true,
            allowDeleting: true,
            allowTaskbarEditing: true,
            showDeleteConfirmDialog: true,
            locale: 'es-CO'
        };
        this.edittimeformat = {type:'date', format:'MMM dd, y'};
        this.edittimeparams = {params:{locale:'es-CO'}};
        this.splitterSettings = {
            columnIndex: 2
        };
        this.projectStartDate = new Date('03/25/2019');
        this.projectEndDate = new Date('07/28/2019');
        this.gridLines = 'Both';
        //console.log(authenticationService.currentUserValue.usuario.email)
        //this a sessionStorage
        this.dataProjects1 = new DataManager({
                              //url: 'http://soportecsi.no-ip.biz:5050/api/v1/proy/usuariop/',
                              url: JSON.parse(sessionStorage.config).HostUrl +'5005/api/v1/proy/usuariop/',
                              adaptor: new WebApiAdaptor(),
                              async: false,
                              //body: {'tareas':this.ganttObj.dataSource},
                              crossDomain: true
                            }).insert( {usuario:authenticationService.currentUserValue.usuario.email} )  //se hace un insert para poder consultar la informacion filtrada por usuario
                            .then(resp => {
                                debugger;
                                this.dataProjects = resp;
                                this.setState({loadingProjects:false} );
                                return resp;
                            });

        //this.dataProjects.insert( {usuario:"orestrepo@csibs.com.co"} ) ;
        debugger;
        //this.dataProjects.insert( {usuario:"orestrepo@csibs.com.co"} ) ;
        this.toolbar = [  //{ type: 'Input', template: new DropDownList(), text: 'Cliente', dataSource: this.dataClientes },
                          'Add', 'Edit', 'Update', 'Delete', 'Cancel', 
                          'ExpandAll', 
                          'CollapseAll', 'Indent', 'Outdent',  
                          { text: 'Save', tooltipText: 'Save Project', id: 'SaveProject', prefixIcon: 'e-save' },
                          'ExcelExport', 'CsvExport', 'PdfExport'];
        this.timelineSettings = {
            topTier: {
                unit: 'Week',
                format: 'MMM dd, y',
            },
            bottomTier: {
                unit: 'Day',
            },
        };
        this.durationUnit = 'day';
        this.labelSettings = {
            leftLabel: 'TaskName',
            rightLabel: 'resources',
            // eslint-disable-next-line
            taskLabel: '${Progress}%'
        };
        this.holidays = [{from:'04/04/2019', to:'04/05/2019', label:'Festivo Local', color:'blue'},
                          {from:'04/07/2019', to:'04/07/2019', label:'Domingo', color:'yellow'}]
        this.eventMarker = [{day:'4/17/2019', label:'Project approval and kick-off'},
                            {day:'5/3/2019', label:'Foundation inspection'},
                            {day:'6/7/2019', label:'Site manager inspection'},
                            {day:'7/16/2019', label:'Property handover and sign-off'}]
        /* this.eventMarkerDay1 = new Date('4/17/2019');
        this.eventMarkerDay2 = new Date('5/3/2019');
        this.eventMarkerDay3 = new Date('6/7/2019');
        this.eventMarkerDay4 = new Date('7/16/2019'); */
        this.contextMenuItems = ['AutoFitAll', 'AutoFit', 'TaskInformation', 'DeleteTask', 'Save', 'Cancel',
            'SortAscending', 'SortDescending', 'Add', 'DeleteDependency', 'Convert', 'Indent', 'Outdent',
            { text: 'Collapse the Row', target: '.e-content', id: 'collapserow' },
            { text: 'Expand the Row', target: '.e-content', id: 'expandrow' }];

        this.data = editingData;

    }

   


    afterTaskbarEdited(args) {
      debugger;
    }

    beforeToolbarRender(args) {
      //debugger;
     }
    contextMenuOpen(args) {
      let record = args.rowData;
      if (args.type !== 'Header') {
          if (!record.hasChildRecords) {
              args.hideItems.push('Collapse the Row');
              args.hideItems.push('Expand the Row');
          }
          else {
              if (record.expanded) {
                  args.hideItems.push('Expand the Row');
              }
              else {
                  args.hideItems.push('Collapse the Row');
              }
          }
      }
  }
  contextMenuClick(args) {
      let record = args.rowData;
      if (args.item.id === 'collapserow') {
          this.ganttObj.collapseByID(Number(record.ganttProperties.taskId));
      }
      if (args.item.id === 'expandrow') {
          this.ganttObj.expandByID(Number(record.ganttProperties.taskId));
      }
  }

  async toolbarClick(args) {
      debugger;
      if (args.item.text === 'Save') {
          console.log('Proyecto Guardado');
          debugger;
          
          let taskSave = new DataManager({
            /* url: 'https://ej2services.syncfusion.com/production/web-services/api/GanttData', */
            //url: 'http://soportecsi.no-ip.biz:5050/api/v1/proy/tareas/',
            //this a sessionStorage
            url: JSON.parse(sessionStorage.config).HostUrl + '5005/api/v1/proy/tareas/',
            adaptor: new WebApiAdaptor(),
            async: false,
            //body: {'tareas':this.ganttObj.dataSource},
            crossDomain: true
          });  
          let projectSend = JSON.stringify(this.ganttObj.dataSource).replace(/,"Predecessor":null/g," ");
          projectSend = projectSend.replace(/,"Predecessor":""/g," ");
          projectSend = projectSend.replace(/,"info":null/g,", \"info\":\"\" ");
          projectSend = projectSend.replace(/,"ParentId":null/g,", \"ParentId\":0");
          var projectSendJson = JSON.parse(projectSend);
          projectSendJson.map(key => {
            var dateObject = new Date(key.EndDate)
            key.EndDate = dateObject.getFullYear() +
            "/" + 
            (dateObject.getMonth()+1) + 
            "/" + 
            dateObject.getDate() +
            " "+
            dateObject.getHours()+
            ":"+
            dateObject.getMinutes() +
            ":"+
            dateObject.getSeconds();
            dateObject = new Date(key.StartDate)
            key.StartDate = dateObject.getFullYear() +
            "/" + 
            (dateObject.getMonth()+1) + 
            "/" + 
            dateObject.getDate() +
            " "+
            dateObject.getHours()+
            ":"+
            dateObject.getMinutes() +
            ":"+
            dateObject.getSeconds();

            return true;
          });
          projectSend = JSON.stringify(projectSendJson);
          debugger;
          await taskSave.insert({"tareas": JSON.parse(projectSend), "projectid":this.projectListObj.value})//.executeQuery(new Query())
                      .then(resp => {
                          //debugger;
                          //let dialog = this.defaultDialogInstance;
                          //dialog.animationSettings = { effect: 'Zoom', duration: 400 };
                          window.alert('Las tareas se han guardado exitosamente.');
                          console.log('Guardar Tareas');
                          console.log(resp);
                          return resp;
                      })
                      .catch(err => {
                        window.alert('Se produjo un error al guardas las tareas.');
                        console.log('Error de Guardado');
                        console.log(err);   
                        return err; 
                      });
      }
      if (args.item.text === 'Quick Filter') {
        this.ganttObj.filterByColumn('TaskName', 'startswith', 'Identify');
      }
      if (args.item.text === 'Clear Filter') {
          this.ganttObj.clearFiltering();
      }
      if (args.item.id === "ganttCSIBS_excelexport") {
          this.ganttObj.excelExport();
      }
      else if (args.item.id === "ganttCSIBS_csvexport") {
          this.ganttObj.csvExport();
      }
      else if (args.item.id === "ganttCSIBS_pdfexport") {
          let exportProperties = {
              fileName: this.projectListObj.text+".pdf",
              //pageOrientation: 'Landscape',
              pageSize:"Letter",
              theme: "Bootstrap 4"
          }
          this.ganttObj.pdfExport(exportProperties);
      }
    }

    onClickGantt () {
      console.log('click tabla');
      console.log(this.ganttObj);
      //console.log(JSON.stringify(this.ganttObj))
      /*console.log(L10n_es) */
   
    }

    actionBegin(args) {
      //debugger
      if (args.requestType === "beforeOpenEditDialog" || args.requestType === "beforeOpenAddDialog") {
          /* var column = this.ganttObj.columnByField["InicioReal"];
          this.divElement = this.ganttObj.createElement("div", {
              className: "e-edit-form-column"
          });
          var inputElement;
          let typecolumn = "text";
          if (column.type) {
            typecolumn = column.type
          }
          inputElement = this.ganttObj.createElement("input", {
              attrs: {
                  //type: column.type,
                  id: this.ganttObj.controlId + "" + column.field,
                  lang:'es',
                  name: column.field,
                  title: column.headerText
              }
          });
          this.divElement.appendChild(inputElement);
          var input = {
              enabled: true,
              floatLabelType: "Auto",
              lang:'es',
              placeholder: "Inicio Real",
              value: args.rowData.InicioReal
          };
          var inputObj = new this.inputs[column.editType](input);
          inputObj.appendTo(inputElement); */
      }
    };
    actionComplete(args) {
      debugger;
      if (args.requestType === "openEditDialog" || args.requestType === "openAddDialog") {
         /*  var generalTab = document.getElementById(this.ganttObj.controlId + "GeneralTabContainer");
          generalTab.appendChild(this.divElement); */
      }
      if (args.requestType === "save") {

        //this.data[args.data['index']].Duration = args.data.Duration + ' ' + args.data.durationUnit +'s';
        //this.ganttObj.dataSource[this.ganttObj.ids[args.data['index']]].Duration = args.data.Duration + ' ' + args.data.durationUnit +'s';
        for (var i=0, numTask=this.ganttObj.dataSource.length; i<numTask; i++) {
          if (this.ganttObj.dataSource[i].TaskID === args.data.TaskID) {
            this.ganttObj.dataSource[i].Duration = args.data.Duration + ' ' + args.data.durationUnit +'s';
            i = numTask;
          }
        }
      }
    };

    componentDidMount() {
      //debugger;

    };

    onChange() {
      debugger;
      this.value = this.projectListObj.value;
      //const l_url = config.HostUrl + this.CfgOptions[this.props.opcion].puerto + config.HostEndUrl + this.CfgOptions[this.props.opcion].endpoint + "?cosecha=" + this.listObj.value;
      //const l_url = 'http://soportecsi.no-ip.biz:5050/api/v1/proy/tareas/'+this.value;
      //this a sessionStorage
      const l_url = JSON.parse(sessionStorage.config).HostUrl + '5005/api/v1/proy/tareas/'+this.value;
      this.setState({ data : null, loading : true });
      console.log('onchange')
      this.data = this.consultarDatos({url:l_url,proyecto:this.value});
    }

    async consultarDatos(args) {
      debugger;
      DataUtil.serverTimezoneOffset = -5;
      DataUtil.timeZoneHandling = true;
      this.dataSource = new DataManager({
        /* url: 'https://ej2services.syncfusion.com/production/web-services/api/GanttData', */
        url: args.url,
        adaptor: new WebApiAdaptor(),
        async: false,
        crossDomain: true
      });

      await this.dataSource.executeQuery(new Query())
                  .then(resp => {
                      debugger;
                      var finalData = JSON.stringify(resp.actual.marcadores);
                      this.eventMarker = DataUtil.parse.parseJson(finalData);
                      finalData = JSON.stringify(resp.actual.festivos);
                      this.holidays = DataUtil.parse.parseJson(finalData);
                      this.resources = resp.actual.recursos;
                      this.data = resp.actual.tareas;
                      /* this.eventMarker = resp.actual.marcadores;
                      this.holidays = resp.actual.festivos;
                      this.resources = resp.actual.recursos;
                      this.data = resp.actual.tareas; */
                      this.projectStartDate = resp.actual.fechas.StartDate;
                      this.projectEndDate = resp.actual.fechas.EndDate;
                      this.setState({ loading : false });

                      return resp;
                  });
    }

    dataBound () {
      debugger;
      //this.projectListObj.index = "";
      if (this.projectListObj && this.projectListObj.listData[0]) {
        this.projectListObj.value = this.projectListObj.listData[0].projectid;
        this.projectListObj.text = this.projectListObj.listData[0].projectname;
        //const l_url = 'http://soportecsi.no-ip.biz:5050/api/v1/proy/tareas/'+this.projectListObj.listData[0].projectid;
        //this a sessionStorage
        const l_url = JSON.parse(sessionStorage.config).HostUrl  + '5005/api/v1/proy/tareas/'+this.projectListObj.listData[0].projectid;
        console.log('databound')
        this.consultarDatos({url:l_url,proyecto:this.projectListObj.listData[0].projectid});
      };
    }

    render() {
        //debugger;
        loadCldr(numberingSystems.default, gregorian.default, numbers.default, timeZoneNames.default, weekData.default);

        //if (this.state.loading === false) {
          /* console.log(editingData) */
          //debugger;
        return (<div className='control-pane'>
          <div className='control-section' id='target_gantt'>
            {/* <GanttComponent id='Editing' dataSource={editingData} dateFormat={'MMM dd, y'} treeColumnIndex={1} allowSelection={true} showColumnMenu={false} highlightWeekends={true} allowUnscheduledTasks={true} projectStartDate={this.projectStartDate} projectEndDate={this.projectEndDate} taskFields={this.taskFields} timelineSettings={this.timelineSettings} labelSettings={this.labelSettings} splitterSettings={this.splitterSettings} height='410px' editSettings={this.editSettings} gridLines={this.gridLines} toolbar={this.toolbar} resourceFields={this.resourceFields} resources={editingResources}> */}
            <div id="analytic_head">
                <div className="header"> 
                  {/* <div className="prueba">Proyecto
                  <h4>prueba</h4></div> */}
                  { this.state.loadingProjects === false &&
                      <div className="combo-content"> Proyecto
                            <ComboBoxComponent id="proyecto" dataSource={this.dataProjects} query={this.queryProjects}
                                            ref={(combobox) => { this.projectListObj = combobox; }} 
                                            fields={this.projectFields} 
                                            change={this.onChange.bind(this)} 
                                            placeholder="Seleccione un proyecto" 
                                            value={this.value} 
                                            dataBound = {this.dataBound.bind(this)}
                                            popupHeight="220px"/>
                      </div>
                  }
                </div>
            </div>
            { this.state.loading === false &&
            <GanttComponent id='ganttCSIBS' dataSource={this.data} dateFormat={'MMM dd, y'} treeColumnIndex={1} 
                  locale='es-CO' durationUnit={this.durationUnit} enableContextMenu={true}
                  toolbarClick={this.toolbarClick.bind(this)} actionBegin={this.actionBegin.bind(this)} actionComplete={this.actionComplete.bind(this)} 
                  contextMenuItems={this.contextMenuItems} contextMenuOpen={this.contextMenuOpen.bind(this)} contextMenuClick={this.contextMenuClick.bind(this)}
                  allowSelection={true} showColumnMenu={false} highlightWeekends={true} allowUnscheduledTasks={true} 
                  allowSorting={true} projectStartDate={this.projectStartDate} projectEndDate={this.projectEndDate} 
                  taskFields={this.taskFields} timelineSettings={this.timelineSettings} 
                  labelSettings={this.labelSettings} splitterSettings={this.splitterSettings} 
                  height='520px' editSettings={this.editSettings} gridLines={this.gridLines} 
                  toolbar={this.toolbar} resourceFields={this.resourceFields} resources={this.resources}
                  onClick = {this.onClickGantt = this.onClickGantt.bind(this)} 
                  toolbarRender={this.beforeToolbarRender.bind(this)} 
                  taskbarEdited={this.afterTaskbarEdited.bind(this)} 
                  renderBaseline={true} baselineColor='green'
                  ref={(scope) => { this.ganttObj = scope; }} //timezone={'America/Bogota'}
                  //allowPaging={true} pageSettings={{ pageCount: 4, pageSizes: true }}
                  allowExcelExport={true} allowPdfExport={true}>
              <ColumnsDirective>
                <ColumnDirective field='TaskID'  width='60'></ColumnDirective>
                <ColumnDirective field='TaskName' headerText='Tarea' width='250' clipMode='EllipsisWithTooltip'></ColumnDirective>
                <ColumnDirective field='StartDate' headerText='Fecha Inicio'></ColumnDirective>
                <ColumnDirective field='Duration' headerText='Duración' type='string'></ColumnDirective>
                <ColumnDirective field='BaselineStartDate' headerText='Fecha Inicio Real'></ColumnDirective>
                <ColumnDirective field='BaselineEndDate' headerText='Fecha Final Real'></ColumnDirective>
                <ColumnDirective field='Progress' headerText='Progreso'></ColumnDirective>
              </ColumnsDirective>
              <EditDialogFieldsDirective>
                <EditDialogFieldDirective type='General' headerText='General'></EditDialogFieldDirective>
                <EditDialogFieldDirective type='Dependency'></EditDialogFieldDirective>
                <EditDialogFieldDirective type='Resources'></EditDialogFieldDirective>
                <EditDialogFieldDirective type='Notes'></EditDialogFieldDirective>
              </EditDialogFieldsDirective>
              <EventMarkersDirective>
                {this.eventMarker.map(key => {
                  //debugger;
                  return <EventMarkerDirective day={key.markdate} label={key.marklabel}></EventMarkerDirective>
                })}
{/*                 <EventMarkerDirective day={this.eventMarkerDay1} label='Project approval and kick-off'></EventMarkerDirective>
                <EventMarkerDirective day={this.eventMarkerDay2} label='Foundation inspection'></EventMarkerDirective>
                <EventMarkerDirective day={this.eventMarkerDay3} label='Site manager inspection'></EventMarkerDirective>
                <EventMarkerDirective day={this.eventMarkerDay4} label='Property handover and sign-off'></EventMarkerDirective>
 */}              </EventMarkersDirective>
              <HolidaysDirective>
                {this.holidays.map(key => {
                  //debugger;
                  let v_startDate = new Date(key.startdate);
                  let v_endDate = new Date(key.enddate);
                  /* let v_timeZoneOffset = new Date(v_startDate).getTimezoneOffset();
                  v_timeZoneOffset = v_timeZoneOffset/60;
                  v_startDate.setHours(v_startDate.getHours()+v_timeZoneOffset);
                  v_endDate.setHours(v_endDate.getHours()+v_timeZoneOffset); */

                  return <HolidayDirective from={v_startDate} to={v_endDate} label={key.nameHoliday} cssClass={'e-holiday-'+key.color}></HolidayDirective>  
                })}
                {/* <HolidayDirective from='04/03/2019' to='04/04/2019' label='Festivo Local' cssClass='e-holiday'></HolidayDirective>
                <HolidayDirective from='04/07/2019' to='04/07/2019' label='Good Friday' cssClass='e-custom-sunday'></HolidayDirective> */}
            </HolidaysDirective>
              <Inject services={[Edit, Selection, Toolbar, DayMarkers, ContextMenu, ExcelExport, PdfExport]}/>
            </GanttComponent>}
          </div>

        </div>);
      /*   } else {
          return (<div className='control-pane'></div>)
        } */
    }
}

